export const SessionStorageKey = {
    expiredAt: 'gt-expiredAt',
    token: 'gt-token',
    expandedFilter: 'gt-expandedFilter'
};